export const SOCKET_STATE = {
  CONNECTING: 0,
  OPEN: 1,
  CLOSING: 2,
  CLOSED: 3,
  NULL: -1,
};

export const SOCKET_EVENTS = {
  CLOSE: 'close',
  OPEN: 'open',
  ERROR: 'error',
  MESSAGE: 'message',
};

export const SOCKET_QUEUE_INTERVAL = 1000;
export const SOCKET_RECONNECT_INTERVAL = 3000;
export const SOCKET_IDLE_WATCH_INTERVAL = 4000;
export const SOCKET_ENUM = {
  ALIVE: 9000,
};

export const SLIKE_GA_ID = process.env.REACT_APP_SLIKE_GA_ID;

export const POOLING_GAP = 2000;

export const ALLOWED_TIME_LAG_DVR = 30; //in sec

export const SOCKET_PRIMARY_ROUTE = {
  CONTROL: ':',
  OPERATION: '$',
  COMM: '@',
  ANALYTICS: '+',
};

export const SOCKET_SECONDARY_ROUTE = {
  DISCONNECT: '000',
  REJECTED: '001',
  USER_DISCONNECT: '002',
  USER_JOINED: '003',
  WELCOME: '004',
  STATS: '001',
  PING: '900',
  NAME_CHANGE: '000',
  PLAYBACK_STARTED: '000',
  FORCE_REJECTED: '005',
  STATE_UPDATE: '006',
  AUD_COUNT: '001',
  RECORDINGS: '008',
  ADMINSCREENSHOT_ADDED: '007',
  USER_BLOCKED: '004',
  COMM_REACTION: '004',
  USER_UNBLOCK: '005',
  CANVAS_ROUTE: '013',
  META_UPDATE: '014',
  PONG: '901',
  PLAYER_ANALYTICS: '000',
  AV_TOKEN: '007',
  BANNER: '009',
  UPDATE_PLAYLIST: '012',
  GET_PLAYLIST: '013',
  L_BAND: '020',
};

export const APP_EVENTS = {
  ENV_READY: 'appEnvReady',
  EVENT_STATUS_CHANGE: 'appEventStatusChange',
  SESSION_CONNECTED: 'appSessionConnected',
  SESSION_REJECTED: 'appSessionRejected',
  SESSION_CLOSED: 'appSessionClosed',
  SESSION_ERROR: 'appSessionError',
  STATE_UPDATE: 'appStateUpdate',
  ADMINSCREENSHOT_ADDED: 'appAdminSsAdded',
  SESSION_EXPIRED: 'appSessionExpired',
  SS_RECEIVED: 'appSsReceived',
  CHAT_HISTORY: 'appChatHistory',
  CHAT_SENT: 'appChatSent',
  CHAT_RECEIVED: 'appChatReceived',
  CHAT_DELETED: 'appChatDelete',
  CHAT_PINNED: 'appChatPin',
  CHAT_UNPINNED: 'appChatUnPin',
  QNA_HISTORY: 'appQnaHistory',
  QNA_SENT: 'appQnaSent',
  CHAT_LOGIN_REQUEST: 'appChatLoginRequest',
  GA_EVENT: 'appGaEvent',
  CHAT_BOX_CLOSE: 'appChatCLose',
  VIDEO_ENDED: 'appVideoEnded',
  USER_CONNECTED: 'appUserConnected',
  READY_TO_USE: 'READY_TO_USE',
};

export const APP_VIEW = {
  WELCOME: 1,
  PROCEED: 2,
  FORCE_PROCEED: 3,
  MAIN: 4,
  END: 5,
  ERROR: 6,
};

export const CHAT_RULES = {
  NEVER_OPENED: 0,
  OPENED: 1,
  ACCEPTED: 2,
};

export const SCREENSHOT_EVENTS = {
  SCREENSHOT_CAPTURED: 'SCREENSHOT_CAPTURED',
  SCREENSHOT_DELETED: 'SCREENSHOT_DELETED',
  DELETE_ALL: 'DELETE_ALL',
  DOWNLOAD_ALL: 'DOWNLOAD_ALL',
  DOWNLOAD: 'DOWNLOAD',
  IS_SCREENSHOT_SUPPORTED: 'IS_SCREENSHOT_SUPPORTED',
  CAPTURE_FAILED: 'CAPTURE_FAILED',
  NO_SS_EXIST: 'NO_SS_EXIST',
  SS_EXIST: 'SS_EXIST',
  CROPPING_END: 'CROPPING_END',
  CROPPING_START: 'CROPPING_START',
  READY_TO_USE: 'READY_TO_USE',
  MOMENT_EVENT: 'MOMENT_EVENT',
};

export const CHAT = {
  _ERROR: 'ERROR',
  MESSAGE_ADDED: 'MESSAGE_ADDED',
  MESSAGE_BROADCAST_RECEIVED: 'MESSAGE_BROADCAST_RECEIVED',
  MESSAGE_SENT: 'MESSAGE_SENT',
  REQUEST_LOGIN: 'REQUEST_LOGIN',
  CLOSE_CHAT: 'CLOSE_CHAT',
  RULES_ACCEPTED: 'RULES_ACCEPTED',
};

export const VIDEO = {
  VIDEO_ENDED: 'VIDEO_ENDED',
};

export const USER = {
  USER_CONNECTED: 'USER_CONNECTED',
};

export const PARENT_ACTION = {
  PLAY: 'PLAY',
  PAUSE: 'PAUSE',
  DESTROY_PLAYER_ON_BG: 'DESTROY_PLAYER_ON_BG',
  RESUME_PLAYER_ON_FG: 'RESUME_PLAYER_ON_FG',
  GET_CHAT_HISTORY: 'GET_CHAT_HISTORY',
  GET_QNA_HISTORY: 'GET_QNA_HISTORY',
  SEND_MESSAGE: 'SEND_MESSAGE',
  SEND_QNA: 'SEND_QNA',
  CREATE_SESSION: 'CREATE_SESSION',
};

export const VOLUME = {
  MUTE: 'MUTE',
  UNMUTE: 'UNMUTE',
};

export const GA = {
  GA_EVENT: 'GA_EVENT',
};

export const EVENT_STATUS = {
  UNKNOWN: -1,
  BOX_WARMING: 1,
  BOX_WARMED: 2,
  EVENT_RUNNING: 3,
  EVENT_ENDING: 4,
  EVENT_ENDED: 5,
};

export const STREAM_STATUS = {
  UNKNOWN: -1,
  NOT_STARTED: 0,
  STARTING: 11,
  RUNNING: 1,
  PAUSING: 19,
  PAUSED: 2,
  ENDED: 3,
};

export const FINAL_EVENT_STATUS = {
  NOT_STARTED: 0,
  STARTING: 1,
  RUNNING: 2,
  PAUSED: 3,
  ENDED: 4,
};

export const GO_LIVE_STATES = {
  NEVER_LIVE: 0,
  STARTED: 1,
  PAUSED: 2,
  ENDED: 3,
};

export const CHAT_BEHAVIOUR = {
  DISABLED: 0,
  ONLY_ADMIN_CAN_BROADCAST: 1,
  ONLY_TO_ADMIN: 2,
  ANY_PRIVATE: 3,
  PUBLIC: 4,
};

export const EVENT_TYPE = {
  HLS_LIVE: 1,
  WB_LIVE: 2,
  WEB_STUDIO: 3,
  SIMULIVE: 4,
  HLS_RECORDING: -1,
  WB_RECORDING: -2,
};

export const SESSION_STATE = {
  NA: -1,
  CONNECTING: 0,
  CONNECTED: 1,
  CLOSED: 3,
  ERROR: 4,
  REJECTED: 5,
};

export const PLAYER_ERROR_CODE = {
  INTERNET: 100,
  LIVE_PAUSED: 101,
  LIVE_ENDED: 102,
};

export const PLAYER_STATES = {
  STARTED: 1,
  PAUSED: 2,
  STOPPED: 3,
};

export const SPL_STREAM_STATUS = {
  NOT_STARTED: -1,
  ENDED: 0,
  RUNNING: 1,
  PAUSED: 2,
};

export const DEFAULT_API_KEY = 'test403web5a8sg6o9ug';

export const ROOM_ID = {
  QNA: '001',
  COMMENTS: '000',
};

export const HOOK_TYPE = {
  POPUP: 1,
  REDIRECT: 2,
  EMITEVENT: 3,
  EMITEVENT_CMS: 0,
};
export const INTERNET_CHECK_URL = 'https://slike.indiatimes.com/feed/image/internet-check.png';

export const JSON_ERROR_CODE = {
  OK: 200,
  REJECTED: 409,
  INVALID_JWT: 401,
  SERVER_ERROR: 500,
  NOT_FOUND: 404,
  BAD_REQUEST: 400,
};

export const CHAT_MODE = {
  CDN_ONLY: 2,
  SOCKET_ONLY: 1,
  LIVE_SDK: 3,
};

export const STATE_MODE = {
  CDN_ONLY: 2,
  SOCKET_ONLY: 1,
};

export const REACTION_ENUM = {
  LIKE: 'like',
  LOVE: 'love',
  WOW: 'wow',
  YAAY: 'yay',
  ANGRY: 'angry',
  SAD: 'sad',
  HAHA: 'haha',
  DISLIKE: 'dlk',
};

export const AUTO_PLAY_BEHAVIOUR = {
  NEVER: 0,
  WITHOUT_SOUND: 1,
  ALLOW: 2,
};

export const MOMENTS_ALLOWED = {
  NO: 0,
  CLIENT_ONLY: 1,
  ADMIN_ONLY: 2,
  BOTH: 3,
};

export const MOMENTS_BEHAVIOR = {
  NONE: 0,
  BRANDING_ONLY: 1,
  ADD_PIC: 2,
};

export const CAST = {
  RECEIVER_ID: process.env.REACT_APP_RECEIVER_ID,
  NAMESPACE: 'urn:x-cast:cast.cleo.live',
};

export const CAST_STATE = {
  NOT_CONNECTED: 0,
  CONNECTED: 2,
  CONNECTING: 1,
};

export const API_KEY_AES_IV = 'IUlvhvjqt7U6OxOI';

export const API_KEY_JSON_URlS = ['https://conf.sli.ke', 'https://tvid.in/sdk/conf'];

export const PREVIEW_AUTO_HIDE_TIME = 30000;

export const MAX_UPLOADED_FILE_SIZE = 5120000;

export const DEFAULT_CONTROL_HIDE_TIMEOUT = 5000;

export const DEFAULT_CHAT_CONFIG = {
  MIN_INPUT_GAP: 1000,
  BATCH_INTERVAL: 2000,
  RENDER_MAX_DELAY: 500,
  INIT_HISTORY: 100,
  INPUT_MAX_LENGTH: 500,
};

export const WB_MAX_USER = 16;

export const PLAYER_BG = {
  DISABLED: 0,
  BLURRED_VIDEO: 1,
  OVERLAY_IMAGE: 2,
  OVERLAY_VIDEO: 3,
  CANVAS_BLURRED_VIDEO: 4,
};

export const STREAM_TYPE = {
  LANDSCAPE: 0,
  PORTRAIT: 1,
};

export const CANVAS = {
  ADD_ITEM: '1',
  REMOVE_ITEM: '2',
  UPDATE_META: '3',
};

export const AV_MODE = {
  NONE: 0,
  AUDIO_ONLY: 1,
  AUDIO_VIDEO_BOTH: 2,
};

export const STREAM_QUALITIES = {
  h90: 'h90',
  h216: 'h216',
  h180: 'h180', // low
  h360: 'h360', // high
};

export const QNA_EVENTS = {
  REQUEST_LOGIN: 'REQUEST_LOGIN',
};

export const LIVESDK_EVENTS = {
  INITIALISED: 'INITIALISED',
  ACTIVE_USER: 'ACTIVE_USER',
  USER_REACTION: 'USER_REACTION',
  CHAT_HISTORY: 'CHAT_HISTORY',
  CHAT_SENT: 'CHAT_SENT',
  CHAT_RECIEVED: 'CHAT_RECIEVED',
  CHAT_DELETED: 'CHAT_DELETED',
  CHAT_PINNED: 'CHAT_PINNED',
  CHAT_UNPINNED: 'CHAT_UNPINNED',
  QNA_HISTORY: 'QNA_HISTORY',
  QNA_SENT: 'QNA_SENT',
  ERROR: 'ERROR',
};

export const REC_TYPE = {
  MANUAL_RECORDING: 0,
  AUTO_DVR: 1,
  CONVERT_TO_VOD: 2,
};

export const AUTH_MODE = {
  NONE: 0,
  JWT: 1,
  EMAIL: 2,
};

export const KEY_CODE = {
  SPACE: 32,
  NEXT: 39,
  PREVIOUS: 37,
};

export const PLAYLIST_MODE = {
  ALL: 0,
  PRIMARY: 1,
  BACKUP: 2,
};

export const BLOCK_TYPE = {
  CHAT: 'c',
  LINK: 'l',
  SESSION: 's',
};

export const STREAM_ID_STR = {
  videoshare: 'vs_',
  screenshare: 'ss_',
  canvas: 'canvas',
  video: '_video',
  audio: '_audio',
  videoshareCardName: "'s video share",
  screenshareCardName: ' is presenting',
};

export const SOURCE = {
  camera: '0',
  microphone: '0',
  screen_share: '1',
  screen_share_audio: '1',
  video_share: '2',
  video_share_audio: '2',
};

export const PUPPET_ID = 'slike-puppet@slike.in';

export const CALLING_STATE = {
  NOT_INITIATED: 0,
  CALL_REQUESTED: 1,
  CALL_CONNECTED: 2,
};

export const LIVESDK_ERROR_CODE = {
  CONNECTION_LOST: '01',
};

export const ACCESS_STATE = {
  CHECKING: -1,
  BLOCKED: 0,
  CAN_ASK: 1,
  GIVEN: 2,
};

export const GRAPHIC_TYPES = {
  LOGO: 'logo',
  BACKGROUND: 'background',
  VIDEOCLIP: 'videoclip',
  TEXTBANNER: 'textBanner',
  OVERLAY: 'overlay',
  CAPTION: 'caption',
  TICKER: 'ticker',
  CHAT_MSG: 'chatMsg',
  QNA: 'qna',
};

export const CANVAS_ITEM_TYPES = {
  USER: '0',
  SCREEN: '1',
  VIDEO: '2',
  ...GRAPHIC_TYPES,
};

export const PLAYLIST_ACTION = {
  PLAY: 1,
};

export const COMPONENT_TYPE = {
  SHORTS_VIDEOS: 1,
  SIMULIVE_PLAYLIST: 2,
};

export const LOGO_POSITIONS = {
  TOP_LEFT: 1,
  TOP_RIGHT: 2,
  BOTTOM_RIGHT: 3,
  BOTTOM_LEFT: 4,
};
